module.exports = __webpack_public_path__ + "static/media/14UNEP22.e8813d58.jpg";